"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MeResponse = exports.UserSummary = exports.MfaCodeInput = exports.LoginInput = void 0;
const zod_1 = require("zod");
const enums_js_1 = require("./enums.js");
exports.LoginInput = zod_1.z.object({
    username: zod_1.z.string().min(1).max(64),
    password: zod_1.z.string().min(8).max(256),
    // P7 MFA — a 6-digit TOTP code, required on the second login step only for
    // accounts with active MFA (the server answers the first attempt with
    // `mfa_required` so the client knows to prompt).
    mfa_code: zod_1.z.string().regex(/^\d{6}$/).optional(),
});
/** Body for the MFA enroll-confirm / disable endpoints. */
exports.MfaCodeInput = zod_1.z.object({
    code: zod_1.z.string().regex(/^\d{6}$/),
});
exports.UserSummary = zod_1.z.object({
    id: zod_1.z.string().uuid(),
    username: zod_1.z.string(),
    display_name: zod_1.z.string(),
    locale: zod_1.z.enum(enums_js_1.Locales).default('fr'),
    roles: zod_1.z.array(zod_1.z.enum(enums_js_1.Roles)),
});
exports.MeResponse = zod_1.z.object({
    user: exports.UserSummary,
    permissions: zod_1.z.array(zod_1.z.string()),
});
//# sourceMappingURL=auth.schema.js.map